import Vue from 'vue'

/**
 * 回款记录查询
 * @param data
 * @returns {*}
 */
export function getNotifyList(data) {
    return Vue.axios({
        url: '/api/notify/list',
        method: 'post',
        data: {...data}
    })
}

/**
 * 消息设为已读
 * @param data
 * @returns {*}
 */
export function readNotify(data) {
    return Vue.axios({
        url: '/api/notify/read',
        method: 'post',
        data: {...data}
    })
}

/**
 * 消息已读情况统计
 * @param data
 * @returns {*}
 */
export function summaryNotify(data) {
    return Vue.axios({
        url: '/api/notify/summary',
        method: 'post',
        data: {...data}
    })
}